import { layout } from '../../App.routing'
import { metrics } from '@news-mono/component-library'
import { homeSegment } from './home-segment'
import { politicsSegment } from './politics-segment'
import { inCaseYouMissedItSegment } from './in-case-you-missed-it-segment'
import { yourMoneySegment } from './your-money-segment'
import { aflSegment } from './afl-segment'
import { moreSportSegment } from './more-sport-segment'
import { opinionSegment } from './opinion-segment'
import { businessSegment } from './business-segment'
import { propertySegment } from './property-segment'
import { foodAndDrinkSegment } from './food-and-drink-segment'
import { brandContentSegment } from './brand-content-segment'
import { regionalSegment } from './regional-segment'
import { travelSegment } from './travel-segment'
import { subscriberExclusive } from './subscriber-exclusive'
import { miscCollectionsSegment } from './misc-collections-segment'
import { entertaimentAndLifestyleSegment } from './entertainment-lifestyle-segment'
import { billboardLeaderboardMrec } from '../ad-units'
import { TheWestSection } from '@news-mono/component-library'
import { coronavirusSegment } from './coronavirus-segment'
import { CheckedComponentInformation } from 'json-react-layouts'
import { cricketSegment } from './cricket-segment'
import { courtsCrimeSegment } from './courts_crime'
import { telethonCountdown } from './telethon-countdown'
import { StaticRoutes, Store } from '@news-mono/web-common'

const rampAdUnit = layout.component({
    type: 'ad-unit',
    props: {
        noticePosition: 'below-center',
        hiddenUntilLoaded: true,
        padding: [0, 0, metrics.thewest.margins.lg, 0],
        slot: {
            id: 'ramp',
            size: 'ramp',
            exclusionLabels: ['NoAds'],
        },
    },
})

export const homepage: StaticRoutes<TheWestSection> = {
    '': ({ getAdTargeting, store }) => ({
        kind: 'page',
        heading: 'The West Australian | Perth, WA, National & World News',
        pageType: 'homepage',
        hideHeading: true,
        refreshOnInactive: true,
        noMetaTitleTemplate: true,
        pageMeta: {
            title: 'The West Australian | Perth, WA, National & World News',
            description:
                'The West Australian is a leading news source in Perth and WA. Breaking local and world news from sport and business to lifestyle and current affairs.',
        },
        adTargeting: getAdTargeting('home', 'default', 'home'),
        section: 'default',

        compositions: [
            mainContentSection(
                [
                    coronavirusSegment,
                    rampAdUnit,
                    subscriberExclusive(),
                    telethonCountdown,
                    inCaseYouMissedItSegment(
                        store.getState().render.renditionType,
                    ),
                    ...billboardLeaderboardMrec('one'),
                    courtsCrimeSegment,
                    politicsSegment,
                    entertaimentAndLifestyleSegment,
                    ...billboardLeaderboardMrec('two'),
                    ...aflSegment,
                    cricketSegment,
                    moreSportSegment,
                    ...billboardLeaderboardMrec('three'),
                    ...businessSegment,
                    opinionSegment,
                    yourMoneySegment,
                    propertySegment,
                    foodAndDrinkSegment,
                    ...brandContentSegment,
                    regionalSegment,
                    ...travelSegment,
                    miscCollectionsSegment,
                ],
                store,
            ),
            layout.composition({
                type: 'thor',
                props: {
                    hasBackgroundFill: false,
                    containerWidth:
                        metrics.thewest.siteMetrics.mainContentWidth,
                    horizontalGutters: 'outerMargin',
                    verticalGutters: 'xl',
                },
                contentAreas: {
                    main: [
                        layout.component({
                            type: 'taboola',
                            props: {
                                taboolaContainerId:
                                    'taboola-below-home-thumbnails',
                                locationType: 'home',
                            },
                        }),
                    ],
                },
            }),
        ],
    }),
}

function mainContentSection(
    components: Array<CheckedComponentInformation>,
    store: Store,
) {
    return layout.composition({
        type: 'thor',
        props: {
            hasBackgroundFill: false,
            containerWidth: metrics.thewest.siteMetrics.mainContentWidth,
            horizontalGutters: false,
            verticalGutters: false,
        },
        contentAreas: {
            main: [
                homeSegment(store),
                layout.nestedComposition({
                    type: 'thor',
                    props: {
                        hasBackgroundFill: false,
                        containerWidth: '100%',
                        verticalGutters: false,
                        horizontalGutters: true,
                    },
                    contentAreas: {
                        main: components,
                    },
                }),
            ],
        },
    })
}
